export default __webpack_public_path__ + "static/media/PRIVACYPOLICY_ko.d58b3a81.docx";